import { styled } from '../theme';
import { FlexRow } from './index';

const ModalFooter = styled(FlexRow)({
    alignSelf: 'stretch',
    'button:first-of-type': {
        borderRadius: '0 0 0 4px',
    },
    'button:last-child': {
        borderRadius: '0 0 4px 0',
    },
});

export default ModalFooter;
